module.exports = __webpack_public_path__ + "static/img/wp.4a18876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wp.png
// module id = V4lv
// module chunks = 1